import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { QuotaAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Customer Renderer
 *
 *
 * @example
 * ```typescript
 * {
 *   field: 'type',
 *   headerName: 'Cliente',
 *   cellRenderer: ,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
    selector: 'app-customer-cell-renderer',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="leading-tight">
        <b class="f-10" *ngIf="customerCode">
        {{ customerCode }} <br>
        </b>
        <span>{{ params.data?.businessPartnerName }}</span>
    </div>
  `,
})
export class CustomerCellRendererComponent implements CellRenderer<QuotaAttributes> {
    @Input() params!: CellRendererParams<QuotaAttributes>;

    get customerCode(): string | null {
        return this.params.data?.businessPartnerCode;
    }
}